
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon?: LucideIcon;
  showProgress?: boolean;
  progressValue?: number;
}

const StatsCard = ({ 
  title, 
  value, 
  icon: Icon, 
  showProgress = false, 
  progressValue = 0 
}: StatsCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`${Icon ? 'flex items-center' : ''}`}>
          {Icon && <Icon className="mr-2 h-4 w-4 text-sage" />}
          <div className="text-2xl font-bold">{value}</div>
        </div>
        {showProgress && (
          <div className="space-y-2 mt-2">
            <Progress value={progressValue} className="h-2" />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
